<script setup lang="ts">
import type { PrimitiveModel } from "@/types";
import type { IOption } from "@/interfaces";
import SVG from "@/stories/displays/SVG/SVG.vue";

interface Props {
  model: PrimitiveModel;
  item: IOption;
  groupId: string;
  enableIcon?: boolean;
}

defineEmits<{
  update: [IOption];
}>();

withDefaults(defineProps<Props>(), {
  enableIcon: true,
});
</script>

<template>
  <button
    type="button"
    class="dropdown-focusable-item focusVisible"
    :class="[
      'px-2 py-4 rounded-lg flex items-center w-full justify-start',
      model === item.value ? 'bg-darkOcean50' : '',
      item.disabled ? 'text-neutral500' : '',
      !item.disabled ? 'hover:bg-neutral50 active:bg-neutral100' : '',
      `dropdown-group-${groupId}`,
      'focus-visible-strong',
    ]"
    @click="$emit('update', item)"
    :disabled="item.disabled"
  >
    <div
      v-if="enableIcon"
      class="flex justify-center items-center w-[24px] mr-2"
    >
      <SVG
        v-if="model === item.value"
        icon="custom-check"
        height="24"
        width="24"
        class="text-darkOcean600"
      ></SVG>
    </div>
    <div class="w-full text-left b300">
      {{ item.title }}
    </div>
  </button>
</template>
